import { useProfileStore } from '../../../../store/profileStore';
import { useThemeStore } from '../../../../store/themeStore';
import Dropdown from '../../../common/Dropdown';

const ProfileQuickSwitch: React.FC = () => {
    const { selectedTheme } = useThemeStore();
    const { profiles, activeProfileId, setActiveProfile } = useProfileStore();

    const options = [
        { label: '✨ Plain Timer', value: '__none__' },
        ...profiles.map((p) => ({ label: p.name, value: p.id })),
    ];

    return (
        <div className="w-40 max-w-[40vw]">
            <Dropdown
                options={options}
                selectedValue={activeProfileId || '__none__'}
                currentTheme={selectedTheme}
                onChange={(id) => setActiveProfile(id === '__none__' ? null : id)}
                buttonBorderColor={selectedTheme.color.point}
            />
        </div>
    );
};

export default ProfileQuickSwitch;
